import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  MenuItem
} from '@material-ui/core';
import { createUnderwrite } from 'api/prospector/prospects';
import { sendClientLog } from 'services/logService';
import { LoadingOverlayWrapper } from 'components/layout';
import ClearIcon from '@material-ui/icons/Clear';
import { appNotify } from 'store/actions';
import { Constants } from 'utilities/constants';

const CreateUnderwriteModal = ({
  isOpen,
  classes,
  selectedRows,
  user,
  setIsOpen,
  refreshButtonClick,
  appNotify
}) => {
  const [importName, setImportName] = useState('');
  const [importOpportunityStatus, setImportOpportunityStatus] = useState(Constants.OpportunityStatus.INITIAL);
  const [modalLoading, setModalLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setImportName('');
      setImportOpportunityStatus(Constants.OpportunityStatus.INITIAL)
    }
  }, [isOpen]);

  function handleSubmit() {
    sendClientLog('Info', `Import - User is importing ${selectedRows.length} properties from Prospects.`);
    setModalLoading(true);
    createUnderwrite(selectedRows, user, importName, importOpportunityStatus).then(data => {
      console.log(data);
      if (data.success === 'success') {
        appNotify(data.message, 'success');
        handleClose();
        refreshButtonClick();  
      } else {
        console.log('error', data);
        appNotify(`Unable to create underwrite - ${data.message}`, 'warning');
        setModalLoading(false);
      }
    })
    .catch(error => {
      console.log(error);
      appNotify(`An error occurred - ${error.message || error}`, 'error');
      setModalLoading(false);
    });
  }

  const handleInputChange = input => {
    setImportName(input);
  }

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
    setModalLoading(false);
    setIsOpen(false);
  }
  return (
    <Dialog
      open={isOpen} 
      onClose={handleClose}
      maxWidth='sm' 
      fullWidth
      classes={{paperScrollPaper: classes.dialog}}>
      <DialogTitle disableTypography={true} className={classes.dialogTitleRoot}>
        <Typography variant={'h6'}>
          <span>Create Underwrite</span>
        </Typography>
        <Typography variant='body1' >{`${selectedRows.length} prospect${selectedRows.length > 1 ? 's' : ''} selected`}</Typography>
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent>
        <LoadingOverlayWrapper
          active={modalLoading}
          message={'Creating Underwrite'}
          className={classes.loadingWrapper}
        >
          <TextField
            className={classes.importName}
            type='text'
            value={importName}
            onChange={e => handleInputChange(e.target.value)}
            label='Import Name'
          />
          <TextField
            label='Opportunity Status'
            className={classes.opportunityStatusSelect}
            value={importOpportunityStatus}
            onChange={e => setImportOpportunityStatus(e.target.value)}
            select
          >
            <MenuItem value={Constants.OpportunityStatus.PRESCREEN}>Pre-Screen</MenuItem>
            <MenuItem value={Constants.OpportunityStatus.INITIAL}>Initial</MenuItem>
          </TextField>
        </LoadingOverlayWrapper>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleClose}>Cancel</Button>
        <Button variant='contained' color='primary' onClick={handleSubmit} disabled={importName === '' || modalLoading}>Import</Button>
      </DialogActions>
    </Dialog>
  );
};

const styles = theme => ({
  loadingWrapper: {
    display: 'flex',
    marginTop: 16
  },
  importName: {
    marginRight: 16,
    flexGrow: 1
  },
  dialogTitleRoot: {
    paddingBottom: 0
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
  overlay: {
    height: 'calc(100vh - (100vh - 100%) - 48px)',
    padding: theme.spacing(2),
    paddingTop: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
  },
  dialog: {
    height: '250px'
  },
  opportunityStatusSelect: {
    width: 150
  }
});

const mapState = state => {
  return {
    user: state.appState.user
  }
};

const mapDispatch = dispatch => {
  return {
    appNotify: (message, variant, options) => dispatch(appNotify(message, variant, options)),
  }
};

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(CreateUnderwriteModal);